
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/rfp",
      function () {
        return require("private-next-pages/download/rfp/index.tsx");
      }
    ]);
  